module.exports = __webpack_public_path__ + "static/umbrella-bot-7781ca8a17a616eee35d2a1f0477f025.jpg";